import { svgShapes } from '@/utils/svgShapes';

export default function ShapeDivider({
    ColorFill = 'primary',
    Shape = 'tilt',
    Flip = '', // Default to an empty string (anything else except "true")
}) {
    const fillColorMap = {
        primary: ['text-primary-800', 'bg-neutral-800'],
        secondary: ['text-secondary-800', 'bg-secondary-800'],
        'dark-secondary': ['text-secondary-900', 'bg-secondary-900'],
        'darker-secondary': ['text-secondary-950', 'bg-secondary-950'],
        'mid-secondary': ['text-secondary-600', 'bg-secondary-600'],
        'light-secondary': ['text-secondary-100', 'bg-secondary-100'],
        'mid-primary': ['text-primary-600', 'bg-primary-600'],
        'light-primary': ['text-primary-100', 'bg-primary-100'],
        'dark-primary': ['text-primary-900', 'bg-primary-900'],
        'darker-primary': ['text-primary-950', 'bg-primary-950'],
        light: ['text-neutral-100', 'bg-neutral-100'],
        dark: ['text-neutral-800', 'bg-neutral-800'],
        default: ['text-white', 'bg-white'],
    };

    const [fillColor, backgroundColor] =
        fillColorMap[ColorFill.trim()] || fillColorMap.default;

    // Check if Flip is exactly 'true', otherwise treat it as false
    const flipClass = Flip.trim() === 'true' ? 'rotate-180' : '';

    const shapeKey = Shape.trim();
    const { path, viewbox, blockSpace, svgSpacing, pathShade, pathShade2 } =
        svgShapes[shapeKey] || svgShapes.tilt;

    return (
        <div className="flex flex-col justify-center">
            <div className="pointer-events-none">
                {/* Show background only if Flip is not 'true' */}
                {!Flip.trim() || Flip.trim() !== 'true' ? (
                    <div className={`${blockSpace} ${backgroundColor}`} />
                ) : null}
                <div
                    className={`relative z-30 w-full ${svgSpacing} ${flipClass} ${fillColor}`}
                    aria-hidden="true"
                >
                    <svg
                        className="block w-full"
                        data-name="Layer 1"
                        xmlns="http://www.w3.org/2000/svg"
                        viewBox={viewbox}
                        preserveAspectRatio="none"
                        focusable="false"
                    >
                        {pathShade && (
                            <path
                                d={pathShade}
                                fill="currentColor"
                                opacity="0.5"
                            />
                        )}
                        {pathShade2 && (
                            <path
                                d={pathShade2}
                                fill="currentColor"
                                opacity="0.1"
                            />
                        )}
                        <path d={path} fill="currentColor" />
                    </svg>
                    {shapeKey === 'curve' && (
                        <span
                            className="absolute inset-x-0 -bottom-1 h-2 bg-current"
                            data-shape-divider-seam="true"
                        />
                    )}
                </div>
                {/* Show background only if Flip is 'true' */}
                {Flip.trim() === 'true' && (
                    <div className={`${blockSpace} ${backgroundColor}`} />
                )}
            </div>
        </div>
    );
}
